<div class="modal-clean modal-clean--wide modal-manage-subscription --centered">
    <div class="modal-clean__content --no-outer-padding">
        <div class="modal-clean__header">
            <div class="modal__close" (click)="close()"></div>
            <div class="modal__title">Manage Subscription</div>
        </div>
        <div class="modal-manage-subscription__container">
            <div class="plan-info-container">
                <div class="plan-info-container__details" *ngIf="user?.subscriptionProduct">
                    <div class="plan-info-container__title">STATUS</div>
                    <div class="plan-info-container__content">
                        <div class="top-title">Your Plan</div>
                        <div class="dot-divider">
                            <span class="dot"></span>
                        </div>
                        <div class="top-plan">
                            {{ getCurrencySymbol(user?.subscriptionProduct?.currency)
                            }}{{ user?.subscriptionProduct?.price }}/{{ getSubscriptionPeriodText() }}
                        </div>
                        <div
                            *ngIf="isSubscribed && user?.subscriptionProduct?.subscriptionState === 'active'"
                            class="top-status --active">
                            <fa-icon [icon]="['tg', 'checked-round']"></fa-icon> Active
                        </div>
                        <div
                            *ngIf="isSubscribed && user?.subscriptionProduct?.subscriptionState === 'cancelled'"
                            class="top-status --cancelled">
                            Cancelled
                        </div>
                        <div *ngIf="!isSubscribed && user?.hasExpiredSubscription()" class="top-status --expired">
                            Expired
                        </div>
                    </div>
                    <div class="plan-info-container__content-wrap">
                        <div class="dot-divider">
                            <span class="dot"></span>
                        </div>
                        <div class="top-plan">
                            {{ getCurrencySymbol(user?.subscriptionProduct?.currency)
                            }}{{ user?.subscriptionProduct?.price }}/{{ getSubscriptionPeriodText() }}
                        </div>
                    </div>
                </div>
                <div class="plan-info-container__desc">An ad-free experience for you and everyone you call.</div>
                <div class="plan-info-container__duration" *ngIf="isSubscribed">
                    <ng-container *ngIf="user?.subscriptionProduct?.subscriptionState === 'active'; else cancelled">
                        Renews on {{ user?.getComputedSubscriptionEndDate() | date: 'longDate' }}
                    </ng-container>
                    <ng-template #cancelled>
                        Subscription expires on {{ user?.getComputedSubscriptionEndDate() | date: 'longDate' }}
                    </ng-template>
                </div>
                <div class="plan-info-container__duration" *ngIf="!isSubscribed && user?.hasExpiredSubscription()">
                    Subscription expired on {{ user?.getComputedSubscriptionEndDate() | date: 'longDate' }}
                </div>
                <div
                    class="plan-info-container__upgrade-row"
                    *ngIf="isSubscribed && user?.isChangeSubscriptionAllowed() && upgradeProduct">
                    <div class="plan-info-container__upgrade-row__content">
                        <div class="__heading">Upgrade Subscription</div>
                        <div class="__subheading">
                            Go Yearly!
                            <span class="__save-text">Save {{ upgradeProduct.savingAmount }}</span>
                        </div>
                    </div>
                    <div class="plan-info-container__upgrade-row__action">
                        <button class="__action button-v2 --purple --rounded" (click)="showUpgradeModal()">
                            Upgrade
                        </button>
                    </div>
                </div>
                <div class="plan-info-container__upgrade-row" *ngIf="!isSubscribed && user?.hasExpiredSubscription()">
                    <div class="plan-info-container__upgrade-row__content">
                        <div class="__heading">Go Ad-Free Again</div>
                        <div class="__subheading">Pick up where you left off.</div>
                    </div>
                    <div class="plan-info-container__upgrade-row__action">
                        <button class="__action button-v2 --purple --rounded" (click)="showUpgradeModal()">
                            Subscribe
                        </button>
                    </div>
                </div>
                <div class="plan-info-container__links-row">
                    <div class="action-container" *ngIf="user?.subscriptionProduct?.subscriptionState === 'active'">
                        <div class="action-link" (click)="goToStore()">Update Payment Information</div>
                    </div>
                    <div class="action-container" *ngIf="user?.subscriptionProduct?.subscriptionState === 'active'">
                        <div class="action-link" (click)="goToCancel()">Cancel Subscription</div>
                    </div>
                    <div class="action-container" *ngIf="user?.subscriptionProduct?.subscriptionState === 'cancelled'">
                        <div class="action-link" (click)="goToRenew()">Renew Subscription</div>
                    </div>
                </div>
            </div>
            <div class="footer-link">
                <div class="action-link"><a href="mailto:support@togethervideoapp.com">Need Help?</a></div>
            </div>
        </div>
    </div>
</div>
